import moment from 'moment';

export default (() => {
  let $modal = $('.edm-modal');

  if ($('.page-id-25743').length) {
    $modal.addClass('open');
  }
  
  $(window).click(function () {
    $modal.removeClass('open');
  })

  $('.edm-modal .modal').click(function (e) {
    e.stopPropagation();
  })

  $('.edm-modal button').click(function () {
    $modal.removeClass('open');
  })

  let options = [
    {
      value: 'accommodation',
      label: 'Accommodation',
    },
    {
      value: 'meeting-events',
      label: 'Meeting & Events',
    },
    {
      value: 'weddings',
      label: 'Weddings',
    },
    {
      value: 'locals',
      label: 'Locals',
    },
    {
      value: 'food-beverage',
      label: 'Food & Beverage',
    },
    {
      value: 'spa',
      label: 'Spa',
    },
    {
      value: 'golf',
      label: 'Golf',
    },
    {
      value: 'kids',
      label: 'Kids',
    },
  ];

  $('.wpcf7-form-control#lists').wrap('<div class="checkbox-select"><span>Interested In <i class="fal fa-chevron-down"></i></span> <div class="dropdown"></div></div>');

  options.forEach((o) => {
    $('.checkbox-select .dropdown').append(`<label>
      <span>${o.label}</span>
      <input type="checkbox" data-val="${o.value}">
    </label>`);
  })

  $('.checkbox-select > span').click(function (e) {
    e.stopPropagation();
    $(this).parent().toggleClass('open');
  })

  $('.checkbox-select .dropdown').click(function (e) {
    e.stopPropagation();
  })

  $('.edm-modal .modal').click(function() {
    $('.checkbox-select.open').removeClass('open');
  })

  $('.checkbox-select input[type=checkbox]').on('change', function () {
    let values = '';
    let $input = $(this).parents('.checkbox-select').find('input[type=hidden]');

    $('.checkbox-select input[type=checkbox]:checked').each(function () {
      values += $(this).attr('data-val') + ',';
    });

    values = values.slice(0, -1);

    $input.val(values);
  });

  $('body').on('DOMNodeInserted', '.drp-calendar', function() {
      $('.daterangepicker').click(function(e) {
        e.stopPropagation();
      })
  });

  function sendEmail(event) {
    var data = {
      full_name: '',
      email: '',
      date_of_birth: '',
      phone: '',
      lists: '',
    }

    if ('25741' == event.detail.contactFormId) {
      var inputs = event.detail.inputs;

      for (var i = 0; i < inputs.length; i++) {
        switch (inputs[i].name) {
          case 'fullName':
            data.full_name = inputs[i].value;
            break;
          case 'email':
            data.email = inputs[i].value;
            break;
          case 'birth':
            data.date_of_birth = moment(inputs[i].value, 'DD-MM-YYYY').format('MM/DD');
            break;
          case 'phone':
            data.phone = inputs[i].value;
            break;
          case 'lists':
            data.lists = inputs[i].value;
            break;
        }
      }

      if (!data.full_name || !data.email || !data.date_of_birth || !data.phone || !data.lists) {
        return;
      }

      $.ajax({
        url: '/mailchimp.php',
        data: JSON.stringify(data),
        type: 'post',
        contentType: 'application/json',
        success: function (response) {
          let data = JSON.parse(response);

          if (data.status == 400) {
            $('#wpcf7-f25741-o2 .wpcf7-response-output').text('Your email is already registered or is invalid!');
            return;
          }

          $('#wpcf7-f25741-o2 .wpcf7-response-output').text('Thank you for your subscription!');
          return;
        },
        error: function (response) {
          $('#wpcf7-f25741-o2 .wpcf7-response-output').text('Unexpected error, try again later or contact a admin.');
          console.log(response);
        },
      })
    }
  }

  document.addEventListener('wpcf7submit', sendEmail, false);
});



// WEBPACK FOOTER //
// ./scripts/components/edm-modal.js